module.exports = __webpack_public_path__ + "static/media/05.4f6c9522.jpg";